import { giphyDarkCharcoal, giphyLightestGrey } from '@giphy/colors'
import styled from 'styled-components'
import { Tabs } from 'ui'
import IconButton from 'ui/src/components/controls/icon-button'

const Header = styled.div`
    display: flex;
`

const CloseButton = styled(IconButton)`
    flex-shrink: 0;
    margin-left: 20px;
`

const Tab = styled(Tabs)`
    width: 100%;
`

type Props = {
    className?: string
    title: string
    onClose?: () => void
}

const CopilotSidebarHeader = ({ className, title, onClose }: Props) => (
    <Header className={className}>
        <Tab labels={[title]} size="small" />
        <CloseButton
            color={giphyDarkCharcoal}
            icon="close"
            iconColor={giphyLightestGrey}
            size="small"
            onClick={() => onClose?.()}
        />
    </Header>
)

export default CopilotSidebarHeader
